async function fetchTagsByPartialName(term) {
    try {
        const url = new URL('/wp-admin/admin-ajax.php', window.location.origin);
        url.searchParams.append('action', 'search_tags');
        url.searchParams.append('term', term);

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin'
        });

        const result = await response.json();

        if (result.success) {
            console.log('Tags found:', result.data);
            return result.data;
        } else {
            console.error('Error fetching tags:', result.data.message);
            return null;
        }
    } catch (error) {
        console.error('Failed to fetch tags:', error);
        return null;
    }
}

async function devtricker_ajax_update_post_tags(post_id, tags) {
    try {
        const form = new FormData();
        form.append('action', 'devtricker_update_post_tags_ajax_action');
        form.append('post_id', post_id);

        tags.forEach((tag, index) => {
            form.append(`tags[${index}]`, tag);
        });
        form.append('nonce', await devtricker_process_getDevtrickerNonce());

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: form
        });

        if (response.status == 200) {
            const result = await response.json();

            if (!result.success) {
                throw new Error(result.data.message);
            }

            devtricker_log(null, devtricker_log_level.INFO, `Tags updated for post ${post_id}`);
            return result.data.tags;
        }

        throw new Error("Failed to update tags. Try again later.");
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}